

























import { defineComponent, ref, computed } from '@vue/composition-api';
import { useMutation } from '@vue/apollo-composable';

import uploadImage from '@/gql/uploadImage.gql';

import i18n from '@/i18n';

const CommonDropzoneWithImageUpload = defineComponent({
  setup(props: any, context: any) {
    const color = ref('white');

    const variables = computed(() => ({
      isBlack: (color.value === 'black'),
      isMain: false,
      folder: props.folder,
    }));

    const mutation = useMutation(uploadImage);

    mutation.onDone((result) => {
      context.emit('done', result?.data.uploadImage);
    });

    // const haveAtLeastOneImage = computed(() => {
    //   if (!props.images) return false;
    //   if (props.images.length < 1) return false;
    //   color.value = props.images[0].isBlackBackground ? 'black' : 'white';
    //   return true;
    // });

    return {
      // haveAtLeastOneImage,
      variables,
      color,
      mutation,
      i18n,
    };
  },
  props: {
    folder: {
      type: String,
      required: true,
      validator: (val: string) => ['HANDICRAFT', 'MEDIA', 'LEARNING_CENTER', 'CREATOR', 'KNOWLEDGE', 'FLOOR_PLAN'].indexOf(val) !== -1,
    },
    images: {},
  },
});

export default CommonDropzoneWithImageUpload;
